<template>
  <div class="projects-index">
    <app-view-layout
      fluid
      header="Lista projektów"
      :items-count="pagination.itemsLength"
    >
      <template #toolbarMenu>
        <ProjectsListToolbarMenu
          v-if="$vuetify.breakpoint.mdAndUp"
          :default-users-filter="ownProjects && user.id"
          @search="fetchProjects"
        />
      </template>

      <template #content>
        <ProjectsListSearchbar @search="fetchProjects" />

        <v-fade-transition mode="out-in">
          <div
            v-if="projectsList.length"
            key="ProjectList"
          >
            <ProjectsList
              v-if="viewMode === 'list'"
              @fetch="fetchProjects"
            />
            <ProjectsTable
              v-else
              @fetch="fetchProjects"
            />
            <AppPagination @change="fetchProjects" />
          </div>

          <AppEmptyList
            v-else
            key="emptyList"
            class="projects-index__empty"
          />
        </v-fade-transition>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import ProjectCard from '@/components/Projects/ProjectCard.vue';
import ProjectsListToolbarMenu from '@/components/Projects/ProjectsListToolbarMenu.vue';
import AppPagination from '@/components/UI/AppPagination.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';
import ProjectsListSearchbar from '@/components/Projects/ProjectsListSearchbar.vue';
import ProjectsList from '@/components/Projects/ProjectsList.vue';
import ProjectsTable from '@/components/Projects/ProjectsTable.vue';

export default {
  props: {
    ownProjects: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AppViewLayout,
    ProjectCard,
    ProjectsListToolbarMenu,
    ProjectsListSearchbar,
    AppPagination,
    AppEmptyList,
    ProjectsList,
    ProjectsTable,
  },

  computed: {
    ...mapState('projects', [
      'projectsList',
      'viewMode',
    ]),
    ...mapState('auth', [
      'user',
    ]),
    ...mapState('pagination', [
      'pagination',
    ]),
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name !== 'project-single') vm.resetProjects();
      if (vm.$route.query.campaignId) vm.setFilters({ campaignIds: [vm.$route.query.campaignId] });
      if (vm.ownProjects) vm.setFilters({ users: [vm.user.id] });
      vm.fetchProjects();
    });
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== 'project-single') this.resetProjects();
    next();
  },

  methods: {
    ...mapActions('dialog', ['showDialog', 'clearDialog']),
    ...mapActions('projects', [
      'fetchProjects',
      'resetProjects',
    ]),
    ...mapActions('filters', [
      'setFilters',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.projects-index {
  &__empty {
    min-height: calc(100vh - 220px);
  }
}
</style>
